"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const maContractCountyEnrollmentNoPdp = {
    name: 'ma-contract-county-enrollment-no-pdp',
    tableType: 'fact',
    grain: [
        'payer-group::key:',
        'zip-geo:fips:fips_state_county_code',
        'year-month::key',
    ],
    tableGrain: [
        '!payer',
        'fips_state_county_code',
        'year_month_key',
    ],
    foreignKeys: [
        'payer::key',
        'payer-group::key',
    ],
};
const maCountyPenetration = {
    name: 'ma-county-penetration',
    tableType: 'fact',
    grain: [
        'zip-geo:fips',
        'year-month::key',
    ],
    tableGrain: [
        'fips',
        'year_month_key',
    ],
    foreignKeys: [],
};
const maPlanCountyEnrollment = {
    name: 'ma-plan-county-enrollment',
    tableType: 'fact',
    grain: [
        'ma-plan::key:',
        'zip-geo:fips:fips_state_county_code',
        'year-month::key',
    ],
    joins: [
        'payer-group::key:',
    ],
    tableGrain: [
        '!payer',
        'fips_state_county_code',
        'year_month_key',
    ],
    foreignKeys: [
        'payer::key',
        'payer-group::key',
    ],
};
const maPlan = {
    name: 'ma-plan',
    altName: 'maplan',
    tableType: 'dim',
    idField: 'plan_id',
    grain: [
        '::key:',
    ],
    joins: [
        'payer::key:',
    ],
    tableGrain: [
        '!ma-plan',
    ],
    foreignKeys: [],
};
const mcoEnrollment = {
    name: 'mco-enrollment',
    tableType: 'fact',
    grain: [
        'payer::key',
        'zip-geo:fips',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'fips',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const medicaidManagedCareEnrollment = {
    name: 'medicaid-managed-care-enrollment',
    tableType: 'fact',
    grain: [
        'zip-geo:fips',
        'year::key',
    ],
    tableGrain: [
        'fips',
        'year_key',
    ],
    foreignKeys: [],
};
const naicAcaReceiptsPaymentsState = {
    name: 'naic-aca-receipts-payments-state',
    tableType: 'fact',
    grain: [
        'payer::key',
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'state_fips',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const naicClaimsState = {
    name: 'naic-claims-state',
    tableType: 'fact',
    grain: [
        'payer::key',
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'state_fips',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const naicExpensesState = {
    name: 'naic-expenses-state',
    tableType: 'fact',
    grain: [
        'payer::key',
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'state_fips',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const naicOtherGainsLossesState = {
    name: 'naic-other-gains-losses-state',
    tableType: 'fact',
    grain: [
        'payer::key',
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'state_fips',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const naicPoliciesLivesGroupsMonthsState = {
    name: 'naic-policies-lives-groups-months-state',
    tableType: 'fact',
    grain: [
        'payer::key',
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'state_fips',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const naicPremiumsState = {
    name: 'naic-premiums-state',
    tableType: 'fact',
    grain: [
        'payer::key',
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'state_fips',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const naicScheduleT = {
    name: 'naic-schedule-t',
    tableType: 'fact',
    grain: [
        'payer::key',
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'state_fips',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const payer = {
    name: 'payer',
    tableType: 'dim',
    grain: [
        '::id',
        '::key',
    ],
    joins: [
        'zip-geo::key',
    ],
    tableGrain: ['!payer'],
    foreignKeys: ['zip-geo::key'],
};
const affiliatedPayer = Object.assign({ ...payer }, { name: 'affiliated-payer' });
const payerGroup = {
    name: 'payer-group',
    tableType: 'dim',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!payer-group'],
    foreignKeys: [],
};
const payerGroupStateMlrAdjustedRebate = {
    name: 'payer-group-state-mlr-adjusted-rebate',
    tableType: 'fact',
    grain: [
        'payer-group::key',
        'year::key',
        'state',
    ],
    tableGrain: [
        '!payer-group',
        'year_key',
        'state',
    ],
    foreignKeys: [
        'payer-group::key',
    ],
};
const payerGroupStateMarketShareBlended = {
    name: 'payer-group-state-market-share-blended',
    tableType: 'fact',
    grain: [
        'payer-group::key',
        'year::key',
        'zip-geo:state_fips',
    ],
    tableGrain: [
        '!payer-group',
        'year_key',
        'state_fips',
    ],
    foreignKeys: [
        'payer-group::key',
    ],
};
const payerStateCali = {
    name: 'payer-state-cali',
    tableType: 'fact',
    grain: [
        'payer::key',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'year_key',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const payerStateMlr = {
    name: 'payer-state-mlr',
    tableType: 'fact',
    grain: [
        'payer::key',
        'year::key',
    ],
    tableGrain: [
        '!payer',
        'year_key',
        'state_fips',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const payerStateMlrAdjustedRebate = {
    name: 'payer-state-mlr-adjusted-rebate',
    tableType: 'fact',
    grain: [
        'payer::key',
        'year::key',
        'state',
    ],
    tableGrain: [
        '!payer',
        'year_key',
        'state',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const payerStateMarketShareBlended = {
    name: 'payer-state-market-share-blended',
    tableType: 'fact',
    grain: [
        'payer::key',
        'year::key',
        'zip-geo::state_fips',
    ],
    tableGrain: [
        '!payer',
        'year_key',
        'state_fips',
    ],
    foreignKeys: [
        'payer::key',
    ],
};
const selfInsuredEmployer = {
    name: 'self-insured-employer',
    tableType: 'fact',
    grain: [
        'year::key',
        'zip-geo::state_fips',
    ],
    tableGrain: [
        'year_key',
        'state_fips',
    ],
    foreignKeys: [],
};
exports.default = [
    maContractCountyEnrollmentNoPdp,
    maCountyPenetration,
    maPlanCountyEnrollment,
    maPlan,
    mcoEnrollment,
    medicaidManagedCareEnrollment,
    naicAcaReceiptsPaymentsState,
    naicClaimsState,
    naicExpensesState,
    naicOtherGainsLossesState,
    naicPoliciesLivesGroupsMonthsState,
    naicPremiumsState,
    naicScheduleT,
    payer,
    affiliatedPayer,
    payerGroup,
    payerGroupStateMlrAdjustedRebate,
    payerGroupStateMarketShareBlended,
    payerStateCali,
    payerStateMlr,
    payerStateMlrAdjustedRebate,
    payerStateMarketShareBlended,
    selfInsuredEmployer,
];
